import axios from "axios";

export const fetchUser = async (token: string) => {
  const { data } = await axios.get(
    `${process.env.REACT_APP_API_URL}/api/professionals`,
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  );
  return data.professional;
};

/**
 * Records that the professional accepted the current payment terms.
 *
 * Takes no body — the timestamp is always the server's clock. The response
 * carries back the instant that was stamped on accountStatus.
 */
export const agreeOnPaymentTerms = async (token: string): Promise<string> => {
  const { data } = await axios.patch(
    `${process.env.REACT_APP_API_URL}/api/professionals/payment-terms`,
    undefined,
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  );
  return data.agreedOnPaymentTerms;
};

export const fetchFichasClinicas = async (token: string) => {
  const { data } = await axios.get(
    `${process.env.REACT_APP_API_URL}/api/professionals/clinicalFilesAccesses`,
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  );
  return data;
};

export const fetchUtente = async (token: string, numero: string | number) => {
  const { data } = await axios.get(
    `${process.env.REACT_APP_API_URL}/api/patients/${numero}`,
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  );
  return data;
};
